// ═══════════════════════════════════════════════════════════════════════════════
// ui--manifesto--text-reveal-v3
// ───────────────────────────────────────────────────────────────────────────────
// Wraps Motion One — letter-by-letter (или word-by-word) reveal на scroll-in.
// Параметры:
//   data-ui--manifesto--text-reveal-v3-mode-value     = "letter" | "word" (default "word")
//   data-ui--manifesto--text-reveal-v3-stagger-value  = seconds (default 0.04)
//   data-ui--manifesto--text-reveal-v3-duration-value = seconds (default 0.7)
// ═══════════════════════════════════════════════════════════════════════════════

import { Controller } from "@hotwired/stimulus"
import { animate, inView } from "motion"

export default class extends Controller {
  static values = {
    mode:     { type: String, default: "word" },
    stagger:  { type: Number, default: 0.04 },
    duration: { type: Number, default: 0.7 },
  }

  connect() {
    const text = this.element.textContent.trim()
    if (!text) return
    this.originalHtml = this.element.innerHTML

    const split = this.modeValue === "letter" ? text.split("") : text.split(" ")
    this.element.innerHTML = split
      .map(s => `<span class="inline-block opacity-0 will-change-transform" style="transform:translateY(40px) rotateX(-45deg);transform-origin:bottom center">${s === " " ? "&nbsp;" : s}${this.modeValue === "word" ? "&nbsp;" : ""}</span>`)
      .join("")

    this.element.style.perspective = "800px"
    this.spans = Array.from(this.element.querySelectorAll("span"))

    this.stop = inView(this.element, () => {
      animate(
        this.spans,
        { opacity: [0, 1], y: [40, 0], rotateX: [-45, 0] },
        { duration: this.durationValue, delay: (i) => i * this.staggerValue, easing: [0.2, 0.8, 0.2, 1] }
      )
    }, { amount: 0.3 })
  }

  disconnect() {
    this.stop?.()
    if (this.originalHtml) this.element.innerHTML = this.originalHtml
  }
}
